export default {
      id: "icon-triangle-usage",
      viewBox: "0 0 14 8",
      url: __webpack_public_path__ + "icons.svg#icon-triangle",
      toString: function () {
        return this.url;
      }
    }